export default __webpack_public_path__ + "static/media/t2.d22b42d3.jpg";